const GetMicroCopy = (content, text) => {
  const microCopy = content()
    .filter(item => item.node.key === text)
    .map(item => item.node.value.value)
  return String(microCopy)
}
export default GetMicroCopy
